<!-- Loading State -->
<div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<!-- Error State -->
<div *ngIf="error && !loading" class="alert alert-danger" role="alert">
    {{ error }}
</div>

<!-- Stats Cards -->
<div *ngIf="stats && !loading" class="row m-0">
    <div class="col-md-4 col-12 p-md-0 pe-md-2 mb-md-0 mb-3">
        <div class="card">
            <div class="card-body">
                <img src="./assets/images/icons/users.png" alt="users icon">
                <div class="card-text">
                    <h5 class="card-title">{{ stats.usersCount }}</h5>
                    <p class="card-subtitle">Members</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 col-12 p-md-0 px-md-2 mb-md-0 mb-3">
        <div class="card">
            <div class="card-body">
                <img src="./assets/images/icons/file_check.png" alt="file_check icon">
                <div class="card-text">
                    <h5 class="card-title">{{ stats.formationsCount }} 15</h5>
                    <p class="card-subtitle">Réservations</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 col-12 p-md-0 ps-md-2 mb-md-0 mb-3">
        <div class="card">
            <div class="card-body">
                <img src="./assets/images/icons/user_card_id.png" alt="user_card_id icon">
                <div class="card-text">
                    <h5 class="card-title">{{ stats.blogsCount }}</h5>
                    <p class="card-subtitle">Agents</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- New Users Cards Section -->
<div *ngIf="stats && !loading" class="users-section mt-4">
    <div class="users-header d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center gap-2">
            <img src="./assets/images/icons/users-small.png" alt="users icon" class="header-icon">
            <h2 class="section-title">Nouveaux membres</h2>
        </div>
        <a href="#" class="view-all-link d-flex align-items-center gap-2">
            Tous afficher
            <img src="./assets/images/icons/link-arrow.png" alt="arrow icon" class="arrow-icon">
        </a>
    </div>

    <div class="users-list">
        <div *ngFor="let user of stats.latestUsers" class="user-card">
            <div class="user-image-container" [class.icon]="!user.profileImage">
                <img *ngIf="user.profileImage" [src]="user.profileImage" [alt]="user.firstName" class="img-fluid">
                <img *ngIf="!user.profileImage" src="./assets/images/icons/user-default-icon.png" alt="">
            </div>
            <div class="user-info">
                <h3 class="user-name">{{ user.firstName }} {{ user.lastName }}</h3>
                <p class="user-email">{{ user.email }}</p>
                <div class="user-sub-info">
                    <p class="user-phone" *ngIf="user.phoneNumber">{{ user.phoneNumber }}</p>-->
                    <p class="user-date">Inscrit le {{ user.createdAt }}</p>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="stats.latestUsers.length === 0" class="text-center py-4">
            <p class="text-muted">Aucun utilisateur trouvé</p>
        </div>

    </div>
</div>